import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const UIVSPatchman = {
    name: 'VS Patch Manager',
    imageUrl: '../../images/VSPatchman.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIVSRootcause = {
    name: 'VS Root Cause',
    imageUrl: '../../images/VSRootcause.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIVSPatchsched = {
    name: 'VS Patch Scheduler',
    imageUrl: '../../images/VSPatchsched.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIVSPatchhist = {
    name: 'VS Patch History',
    imageUrl: '../../images/VSPatchhist.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIVSPatchhistlog = {
    name: 'VS Patch History log',
    imageUrl: '../../images/VSPatchhistlog.png',
    imageSize: "99%",
    bradius: 20,
  };


export const VSPatchman = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Patch Manager</b><br/><br/>
      On the Patch Manager page, you can view the root causes of all the vulnerabilities found during 
      scans, and schedule patches to address these root causes and associated CVEs.<br/><br/>
      The Unique CVE Breakdown chart shows the number of CVEs for Workstations and Servers, broken 
      down by severity. Keep in mind that a single CVE can exist on Workstations AND Servers, so the 
      CVE is counted ONCE in the "Total Unique" value, but may appear and be counted for both 
      workstations and servers. <br/><br/>
      To view the result and history of patch activity, click the blue View Patch History button.
      </div>
      <div style={helpimg}>
      <img
        src={UIVSPatchman.imageUrl}
        alt={'Image of ' + UIVSPatchman.name}
        style={{
          width: UIVSPatchman.imageSize,
          borderRadius: UIVSPatchman.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const VSRootcause = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Root Cause Breakdown</b><br/><br/>
      In the Root Cause Breakdown, clicking on the No. of CVEs will display all the CVEs that were 
      discovered likely due to this root cause. In many cases, root causes can be responsible for 
      triggering multiple CVEs. Each CVE is a link that provides a summary of that CVE.  <br/><br/>
      To see the targets impacted by each root cause, click on the icons in the Workstations and 
      Servers columns (in the Root Cause table). Clicking on the target icon will show you the 
      list of workstations or servers impacted by the root cause. Each target listed is a link 
      to a summary of the vulnerability status of that target. <br/><br/>
      Clicking on the Patch button under Action will allow you to schedule a patch or software 
      update to address this root cause.  <br/><br/>
      Reasons for a Patch button not showing: <br/>
      <ul style={{marginLeft: '4em'}}>
      <li>The target was not scanned by a local agent. Only scans performed by a local agent installed 
      on that target can be patched. If the target has an agent, but the scan was performed by another 
      agent, the target must be re-scanned from its own agent first. </li>      
      <li>A software update (or patch) has been executed already, but no new scans have run since. 
      To update the root cause list (including the need for patching), run a new scan after patches 
      or updates have been applied. </li>
      <li>The root cause is not associated with an application or patch that is supported by CYRISMA patch management. </li>
      </ul>
      </div>
      <div style={helpimg}>
      <img
        src={UIVSRootcause.imageUrl}
        alt={'Image of ' + UIVSRootcause.name}
        style={{
          width: UIVSRootcause.imageSize,
          borderRadius: UIVSRootcause.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const VSPatchsched = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Patch Scheduler</b><br/><br/>
      The top-level date picker schedules <b>ALL</b> targets for convenience. Once a scheduled update and 
      restart time have been selected, the dates and times can be individually adjusted for each target. <br/><br/>
      Target restarts are generally not necessary. However, this is <b>dependent on the application being 
      updated</b>and what its requirements are. If a restart is needed, select the scheduled restart time 
      from the scheduler. <br/><br/>
      <b>Please note,</b> if the agent or target are offline or suspended during the scheduled restart time, 
      the restart will occur when the target resumes. 
      </div>
      <div style={helpimg}>
      <img
        src={UIVSPatchsched.imageUrl}
        alt={'Image of ' + UIVSPatchsched.name}
        style={{
          width: UIVSPatchsched.imageSize,
          borderRadius: UIVSPatchsched.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const VSPatchhist = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Patch History</b><br/><br/>
      To view the result and history of patch activity, click the blue Patch History button at the 
      top right of the Patch Manager page.<br/><br/><br/><br/>
      For any patch attempt, further detail may be found by clicking the icon under the Log column. 
      This may help troubleshoot an issue with an update that did not complete successfully. There 
      may be cases where application updates will need to be performed from the target directly.
      <br/><br/>
      <img
        src={UIVSPatchhistlog.imageUrl}
        alt={'Image of ' + UIVSPatchhistlog.name}
        style={{
          width: UIVSPatchhistlog.imageSize,
          borderRadius: UIVSPatchhistlog.bradius,
        }}
      />
      </div>
      <div style={helpimg}>
      <img
        src={UIVSPatchhist.imageUrl}
        alt={'Image of ' + UIVSPatchhist.name}
        style={{
          width: UIVSPatchhist.imageSize,
          borderRadius: UIVSPatchhist.bradius,
        }}
      />
      </div>
    </div>
  );
};
